import classNames from "classnames";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { TEventType } from "../../types";
import styles from "./styles.module.css";

interface Props {
  eventType: TEventType;
  eventBody: ReactNode;
  extraContent?: ReactNode;
  className?: string;
}

export const EventCard = ({
  eventType,
  eventBody,
  extraContent,
  className,
}: Props) => {
  const cls = classNames(
    styles["event-card-container"],
    eventType === "status" && styles["event-status"],
    eventType === "progress" && styles["event-progress"],
    eventType === "message" && styles["event-message"],
    className
  );
  const { t } = useTranslation();

  const title =
    eventType === "status"
      ? t("research.event_status").toUpperCase()
      : eventType === "progress"
        ? t("research.event_progress").toUpperCase()
        : t("research.event_message").toUpperCase();

  return (
    <div className={cls}>
      <div className={styles["event-card-header"]}>
        <span className={styles["event-card-title"]}>{title}</span>
        {extraContent}
      </div>
      {eventBody}
    </div>
  );
};
